import { EeClassesTypes } from 'types/electionService';
import clsx from 'clsx';
import { getClassIcon } from 'global/utils/election/subscriberClassHelper';
import React from 'react';
import { createStyles } from './styles';

interface EeClassTypeTitleProps {
  type: EeClassesTypes;
  styles?: string;
}

const EeClassTypeTitle = ({ type, styles }: EeClassTypeTitleProps): JSX.Element => {
  const classes = createStyles();
  return (
    <p className={clsx(classes.classTypeTitle, styles)}>
      {getClassIcon(type)}
      <span className={classes.classTypeText}>{type}</span>
    </p>
  );
};

export default EeClassTypeTitle;
